var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-field',{attrs:{"label":"Auto Refresh"}},[_c('b-switch',{on:{"input":function($event){return _vm.toggle()}},model:{value:(_vm.autoRefresh),callback:function ($$v) {_vm.autoRefresh=$$v},expression:"autoRefresh"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }